import { gql } from 'apollo-boost'

const DOCUMENT_MENU_SCRAPING_RESPONSE = gql`
  query documentMenuScrapingResponse($documentMenuScrapingJobId: ID!) {
    documentMenuScrapingResponse(
      documentMenuScrapingJobId: $documentMenuScrapingJobId
    ) {
      id
      menuId
      data
    }
  }
`

export default DOCUMENT_MENU_SCRAPING_RESPONSE
